<template lang="pug">
  ul.v-tabs(
    :class="classes")
    v-tab(
      v-for="(item, index) in options"
      :key="index"
      :active="isActive(item)"
      @click="onSelect(item)")
      | {{ item.name | translate }}
</template>

<script>
export default {
  name: 'VTabs',

  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: null
    }
  },

  created () {
    if (!this.value) {
      this.onSelect(this.options[0])
    }
  },

  computed: {
    classes () {
      return {
        'v-tabs--vertical': this.vertical
      }
    }
  },

  methods: {
    isActive (item) {
      return this.value && this.value.id === item.id
    },

    onSelect (item) {
      this.$emit('input', item)
    }
  }
}
</script>

<style lang="scss">
@import '@/sass/abstracts/_variables.scss';

.v-tabs {
  display: flex;

  &--vertical {
    padding: 2rem 0;
    flex-direction: column;
    gap: 1rem;
  }

  .v-tab {
    cursor: pointer;
    padding: 1.2rem 0;
    font-size: 1.4rem;
    list-style: none;

    &--active {
      cursor: default;
    }
  }

  &--vertical .v-tab {
    padding: 1rem 1.5rem;
    border-radius: 1rem;
    min-height: 5rem;
    display: flex;
    align-items: center;
    transition: background-color 0.2s ease;
    word-break: break-word;
    &:hover {
      background: #EEEEEE;
    }

    &--active {
      background: #BDEDCA;
      font-weight: 900;
      font-size: 1.6rem;
      &:hover {
      background: #BDEDCA;
    }
    }
  }
}
</style>
